import {
  GET_SEGMENTS_SUCCESS,
  GET_SEGMENTS_WATCHER,
  GET_SEGMENTS_FAILED,
  GET_SURVEY_TYPES_WATCHER,
  GET_SURVEY_TYPES_SUCCESS,
  GET_SURVEY_TYPES_FAILED,
  GET_SCOPE_TYPES_WATCHER,
  GET_SCOPE_TYPES_SUCCESS,
  GET_SCOPE_TYPES_FAILED,
  CREATE_MEASUREMENT_WATCHER,
  CREATE_MEASUREMENT_SUCCESS,
  CREATE_MEASUREMENT_FAILED,
  GET_ORGANIZATION_SURVEYS_WATCHER,
  GET_ORGANIZATION_SURVEYS_SUCCESS,
  GET_ORGANIZATION_SURVEYS_FAILED,
  GET_SEGMENTS_SURVEYS_WATCHER,
  GET_SEGMENTS_SURVEYS_SUCCESS,
  GET_SEGMENTS_SURVEYS_FAILED,
} from "./constants"

export function getSegmentsWatcher(payload) {
  return {
    type: GET_SEGMENTS_WATCHER,
    payload,
  }
}

export function getSegmentsSuccess(payload) {
  return {
    type: GET_SEGMENTS_SUCCESS,
    payload,
  }
}

export function getSegmentsFailed(payload) {
  return {
    type: GET_SEGMENTS_FAILED,
    payload,
  }
}

export function getSurveyTypesWatcher(payload) {
  return {
    type: GET_SURVEY_TYPES_WATCHER,
    payload,
  }
}

export function getSurveyTypesSuccess(payload) {
  return {
    type: GET_SURVEY_TYPES_SUCCESS,
    payload,
  }
}

export function getSurveyTypesFailed(payload) {
  return {
    type: GET_SURVEY_TYPES_FAILED,
    payload,
  }
}

export function getScopeTypesWatcher(payload) {
  return {
    type: GET_SCOPE_TYPES_WATCHER,
    payload,
  }
}

export function getScopeTypesSuccess(payload) {
  return {
    type: GET_SCOPE_TYPES_SUCCESS,
    payload,
  }
}

export function getScopeTypesFailed(payload) {
  return {
    type: GET_SCOPE_TYPES_FAILED,
    payload,
  }
}

// CREATE MEASUREMENT
export function createMeasurementWatcher(payload) {
  return {
    type: CREATE_MEASUREMENT_WATCHER,
    payload,
  }
}

export function createMeasurementSuccess(payload) {
  return {
    type: CREATE_MEASUREMENT_SUCCESS,
    payload,
  }
}

export function createMeasurementFailed(payload) {
  return {
    type: CREATE_MEASUREMENT_FAILED,
    payload,
  }
}

export function getOrganizationSurveysWatcher(payload) {
  return {
    type: GET_ORGANIZATION_SURVEYS_WATCHER,
    payload,
  }
}

export function getOrganizationSurveysSuccess(payload) {
  return {
    type: GET_ORGANIZATION_SURVEYS_SUCCESS,
    payload,
  }
}

export function getOrganizationSurveysFailed(payload) {
  return {
    type: GET_ORGANIZATION_SURVEYS_FAILED,
    payload,
  }
}

export function getSegmentsSurveysWatcher(payload) {
  return {
    type: GET_SEGMENTS_SURVEYS_WATCHER,
    payload,
  }
}

export function getSegmentsSurveysSuccess(payload) {
  return {
    type: GET_SEGMENTS_SURVEYS_SUCCESS,
    payload,
  }
}

export function getSegmentsSurveysFailed(payload) {
  return {
    type: GET_SEGMENTS_SURVEYS_FAILED,
    payload,
  }
}
